<template>
  <div class="home">
    <!-- 标题 -->
    <div class="title123">惠企全芯办</div>

    <!-- 表单 -->
    <form class="form-list">
      <!-- 预约事项 -->
      <div>
        预约事项<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <van-radio-group v-model="list.service_id" direction="horizontal" class="radio" @change="getadressdata">
        <van-radio name="1">业务办理</van-radio>
        <van-radio name="2">活动预约</van-radio>
        <van-radio name="3">徐州华创苑</van-radio>
      </van-radio-group>
      <!-- 单位名称 -->
      <div style="padding-top: 16px;">
        单位名称<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <van-cell-group inset style="margin: 0;">
        <van-field placeholder="请输入单位名称" class="input" :class="{ 'input_active': isinput == 1 }" @blur="isinput = 0"
          @focus="isinput = 1" v-model="list.company" />
      </van-cell-group>
      <!-- 活动名称 -->
      <div style="padding-top: 16px;" v-if="list.service_id !== '1'">
        活动名称<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <van-cell-group inset style="margin: 0;" v-if="list.service_id !== '1'">
        <van-field placeholder="请输入活动名称" class="input" :class="{ 'input_active': isinput == 2 }" @blur="isinput = 0"
          @focus="isinput = 2" v-model="list.name" />
      </van-cell-group>
      <!-- 联系人 -->
      <div style="padding-top: 16px;">
        {{list.service_id === '1' ? '办事人' : '联系人'}}<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <van-cell-group inset style="margin: 0;">
        <van-field :placeholder="list.service_id === '1' ? '请输入办事人姓名' : '请输入联系人姓名'" class="input" :class="{ 'input_active': isinput == 3 }" @blur="isinput = 0"
          @focus="isinput = 3" v-model="list.username" />
      </van-cell-group>
      <!-- 联系电话 -->
      <div style="padding-top: 16px;">
        联系电话<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <van-cell-group inset style="margin: 0;">
        <van-field placeholder="请输入联系电话" class="input" :class="{ 'input_active': isinput == 4 }" @blur="isinput = 0"
          @focus="isinput = 4" v-model="list.phone" @input="(val) => { list.phone = val.replace(/[^\d]/g, ''); }" />
      </van-cell-group>

      <!-- 预约场地 -->
      <div style="margin-top: 16px;" v-if="list.service_id !== '1'">
        预约场地<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <van-dropdown-menu class="uplode" style="margin-top: 8px;" active-color="#1A5194" v-if="list.service_id !== '1'">
        <van-dropdown-item :title="adress" v-model="list.area_id" :options="options" class="changdi"
          @change="changeadress" />
      </van-dropdown-menu>
      <!-- 日期 -->
      <div style="margin-top: 16px;">
        预约日期<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <van-cell class="date" :title="date ? '' : '请选择预约日期'" @click="show = true"
        style="border-top:1px solid #eee;border-bottom:1px solid #eee;border-left:1px solid #eee;">
        <template v-if="date" #title>
          <span class="selected-date">{{ date }}</span>
        </template>
      </van-cell>
      <van-calendar v-model="show" @confirm="onConfirm" color="#1A5194"
        style="border-top:1px solid #eee;border-bottom:1px solid #eee;border-right:1px solid #eee;" />
      <!-- 时间 -->
      <div style="margin-top: 16px; margin-bottom: 10px;">
        预约时间<i class="iconfont icon-bitian" style="color:#FF1F1F"></i>
      </div>
      <div class="time-box">
        <div class="box" :class="{ 'box-active': list.time == 1 }" @click="list.time = 1">上午</div>
        <div class="box" :class="{ 'box-active': list.time == 2 }" @click="list.time = 2">下午</div>
        <div class="box" :class="{ 'box-active': list.time == 3 }" @click="list.time = 3">全天</div>
      </div>
      <!-- 事件详情 -->
      <div style="margin-top: 16px; margin-bottom: 10px;">
        {{list.service_id === '1' ? '办理事项' : '事件详情'}}
      </div>
      <textarea :placeholder="list.service_id === '1' ? '请简单介绍办理事项' : '请简单介绍活动具体情况'" v-model="list.description"
        style="border: 1px solid #d4d4d4; width: 100%;resize:none;height: 80px;padding: 4px 10px;box-sizing: border-box;"></textarea>
      <!-- 提交按钮 -->
      <div style="width: 100%px; text-align: center;">
        <van-button color="#1C57A4" size="large"
          style="margin-top:60px;box-shadow:0 0 20px;border-radius:4px ; height: 50px; width: 320px;margin-bottom: 30px;"
          @click="handle">确认提交</van-button>
      </div>
    </form>
    <div></div>
    <div class="image-box">
      <img src="@/assets/image/zclj.jpg">
      <a href="https://www.xzsme.js.cn/">
        <img src="@/assets/image/qyfwpt.jpg">
      </a>
      <a href="https://www.jszwfw.gov.cn/">
        <img src="@/assets/image/jszwfww.jpg">
      </a>
    </div>
    <div class="image-box">
      <img src="@/assets/image/zydj.jpg">
      <img src="@/assets/image/qhb.jpg">
      <img src="@/assets/image/xzrcw.jpg">
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getadressList } from '../api/index'
import { postList } from '../api/index'

export default {
  name: 'HomeView',
  data() {
    return {
      adress: '请选择预约场地',
      date: '',
      show: false,
      list: {
        service_id: '1',
        area_id: 0,
        company: '',
        username: '',
        name: '',
        phone: '',
        date: '',
        time: 1,
        description: '',
      },
      isinput: 0,
      time: 1,
      options: [],
      params: {
        page: 1,
        limit: 10
      }

    }
  },
  created() {
    this.getadressdata()
  },
  methods: {
    changeadress(e) {
      this.adress = e
    },
    formatDate(date) {
      this.list.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      this.date = this.formatDate(date);
    },
    //获取地址信息
    async getadressdata() {
      // 清空表单内容
      this.list.company = '';
      this.list.name = '';
      this.list.username = '';
      this.list.phone = '';
      this.list.date = '';
      this.date = '';
      this.list.description = '';
      
      // 业务办理不需要场地选择
      if(this.list.service_id === '1') {
        this.adress = '无需选择场地'
        this.list.area_id = 0
        this.options = []
        return
      }
      
      let data = await getadressList(this.list.service_id)
      if (data && data.data && data.data.list && data.data.list.length > 0) {
        this.adress = data.data.list[0].name
        this.list.area_id = data.data.list[0].name
        this.options = data.data.list
        this.options.forEach(item => {
          item.text = item.name
          item.value = item.name
        });
      } else {
        this.adress = '暂无可用场地'
        this.list.area_id = ''
        this.options = []
      }
    },
    // 提交按钮
    async handle(e) {
      e.preventDefault()
      
      try {
        // 如果是业务办理，确保name字段有值
        if(this.list.service_id === '1' && !this.list.name) {
          this.list.name = this.list.company + '-业务办理'
        }
        
        // 只有非业务办理才需要处理area_id
        if(this.list.service_id !== '1') {
          this.options.forEach(item => {
            if (item.value == this.list.area_id) {
              this.list.area_id = item.id
            }
          });
        } else {
          // 业务办理时不需要area_id
          this.list.area_id = 0
        }
        
        // 验证必填字段
        if (!this.list.company) {
          Toast('请输入单位名称');
          return;
        }
        if (this.list.service_id !== '1' && !this.list.name) {
          Toast('请输入活动名称');
          return;
        }
        if (!this.list.username) {
          Toast(`请输入${this.list.service_id === '1' ? '办事人' : '联系人'}姓名`);
          return;
        }
        if (!this.list.phone) {
          Toast('请输入联系电话');
          return;
        }
        if (!this.list.date) {
          Toast('请选择预约日期');
          return;
        }
        
        let data = await postList(this.list)
        console.log(data)
        if (data.code == 0) {
          Toast('预约成功')
        } else {
          console.log(data)
          Toast(data.data.msg || '提交失败，请稍后再试')
        }
      } catch (error) {
        console.error('提交失败:', error);
        Toast('网络连接失败，请检查网络后重试');
      }
    },
  }
}
</script>

<style lang="less">
.home {
  padding-bottom: 80px;
}
.image-box {
  padding: 10px 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  img {
    height: 100px;
    width: auto;
  }
}

/* 防止iOS设备缩放 */
input, textarea, select {
  font-size: 16px !important; /* iOS设备会在小于16px字体的输入框被点击时自动缩放 */
  -webkit-text-size-adjust: 100%;
  -webkit-appearance: none; /* 移除iOS默认样式 */
}

.date .van-cell__title {
  span {
    font-size: 12px;
    color: #CDCDCD
  }
}

.selected-date {
  color: #1A5194 !important;
  font-size: 14px !important;
  font-weight: bold;
}

.van-dropdown-menu__item {
  border: 1px solid #eee;
  width: 100%;
}

.van-cell {
  border: 1px solid #eee;
  margin-top: 8px;
}

.changdi {
  width: 100%;
  height: 30px;
  // border:1px solid # ;
}

.time-box {
  display: flex;
  justify-content: space-around;

  .box {
    border-radius: 4px;
    width: 30%;
    height: 40px;
    border: 1px solid #D4D4D4;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    color: #CDCDCD
  }

  ;

  .box-active {
    color: #fff;
    background-color: #1C57A4;
  }

}

.form-list {
  padding: 30px;

  .input {
    border: 1px solid #eee;
    margin-top: 0px;
    border-radius: 7px;
  }

  .input_active {
    border: 1px solid #1A5194;
  }
}

.radio {
  margin-top: 10px;
  display: flex;
  justify-content: space-around;
}

.title123 {
  width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  background-color: #1A5194;
  color: #fff;
  font-size: 18px;
}
</style>
